define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi",
	"csi/heading/_base",
	"csi/heading/EnumAction",
	"csi/heading/EnumActionController",
	"csi/heading/stateColorResolver",
	"csi/heading/Time",
	"csi/reflection",
	"csi/xml"
], function(declare, domClass, csi, heading, EnumAction, EnumActionController, stateColorResolver, Time, reflection, xml) {

	return declare(EnumAction, {
		TYPE_COLOR: "CollectionColorRevision",
		TYPE_MATERIAL: "CollectionMaterialRevision",
		STATUS_NA: "ColorMaterialStatus:Not Applicable",

		_getValue: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			var cache = ctx.cache;
			var node = ctx.getNode();

			if (node.$Type == this.TYPE_COLOR) {
				var collectionColor = cache.getNode(node.__Parent__);
				var collectionMaterial = cache.getNode(collectionColor.__Parent__);
				if (!collectionMaterial.ApprovalNeeded) return this.STATUS_NA;

				var actualMaterial = cache.getNode(collectionMaterial.Material);
				if (actualMaterial && actualMaterial.Managed) {
					var actualColor = cache.getNode(collectionColor.PhasedColor);
					return actualColor ? actualColor.Status : "";
				}

				return node.State;
			} else if (node.$Type == this.TYPE_MATERIAL) {
				var collectionMaterial = cache.getNode(node.__Parent__);
				if (!collectionMaterial.ApprovalNeeded) return this.STATUS_NA;

				var actualMaterial = cache.getNode(collectionMaterial.Material);
				if (actualMaterial && actualMaterial.Managed) {
					return actualMaterial.Status;
				}

				return node.State;
			}

			return "";
		},

		_getValueTime: function(/*csi.def.Context*/ctx) {
			var cache = ctx.cache;
			var node = ctx.getNode();

			if (node.$Type == this.TYPE_COLOR) {
				var collectionColor = cache.getNode(node.__Parent__);
				var collectionMaterial = cache.getNode(collectionColor.__Parent__);
				if (!collectionMaterial.ApprovalNeeded) return null;

				var actualMaterial = cache.getNode(collectionMaterial.Material);
				if (actualMaterial && actualMaterial.Managed) {
					var actualColor = cache.getNode(collectionColor.PhasedColor);
					if (actualColor) return actualColor.StatusTime;
				}
			} else if (node.$Type == this.TYPE_MATERIAL) {
				var collectionMaterial = cache.getNode(node.__Parent__);
				if (!collectionMaterial.ApprovalNeeded) return null;

				var actualMaterial = cache.getNode(collectionMaterial.Material);
				if (actualMaterial && actualMaterial.Managed) return actualMaterial.StatusTime;
			}

			return null;
		},

		headingToHtml: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h, /*DOMNode*/refNode) {
			var res = this.inherited(arguments);
			var value = this._getValue(ctx, h);

			const type = xml.enumGetId(value);
			const index = xml.enumGetText(value);

			const css = stateColorResolver.getStateCssByIndex(type, index);
			domClass.add(refNode, css);

			return res;
		},

		_getRenderAction: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: only allow editing if material is unmanaged
			var value = this._getValue(ctx, h);
			return (xml.enumGetId(value) == reflection.REVISION_STATE_ENUM) ? this.inherited(arguments) : null;
		},

		_toHtmlSub: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/sh, /*DOMNode*/refNode) {
			// if status comes from referenced color/material, then replace time with StatusTime of color/material
			var ad = this.inherited(arguments);

			var valueTime = this._getValueTime(ctx);
			if (valueTime) {
				refNode.lastChild.innerHTML = csi.EMPTY_CHAR + heading.format(xml.ATTR_TIME, sh.m_format, valueTime);
			}

			return ad;
		}
	});
});